import { AHIcon, Circle, CircleSize, useLayoutContext } from "arkh";
import React from "react";

export function TodoCircleNew(props: {
  size: CircleSize;
  status: "DONE" | "PENDING";
  expired: boolean;
}) {
  const circleSize = useLayoutContext().circle[props.size];
  return (
    <Circle
      borderWidth={2}
      size={props.size}
      borderColor={
        props.status === "DONE"
          ? "status-positive"
          : props.expired
            ? "status-negative"
            : "status-active"
      }
      color={props.status === "DONE" ? "status-positive" : "transparent"}
      style={{ justifyContent: "center", alignItems: "center", padding: 2 }}
    >
      {props.status === "DONE" ? (
        <AHIcon
          type="check"
          color="text-inverted"
          forceSize={circleSize * 0.5}
        />
      ) : null}
    </Circle>
  );
}
